<template>
  <div id="room-item-management">
    <info-box v-bind:description="description"></info-box>
    <header-title title="LOOT BOX EDITOR" />
    <span v-if="notification">{{notification}}</span> 
    <h1 v-if="!existingItem">Create Loot Box</h1>
    <h1 v-else>Editing Loot Box {{existingItem.id}}</h1>
    <div>
      <div><router-link class="nav-link" to="/loot-box-management">Back to list</router-link></div>
      <!-- <loading
        :show="isSaving"
        label="Saving">
      </loading> -->
      <table border=1 style="width:100%;">
        <tr>
          <td>Name</td><td><input type="text" placeholder="Enter" align="center" v-model="itemName"/></td>
          <td></td>
          <td>Description</td><td><input type="text" placeholder="Enter" align="center" v-model="itemDescription"/></td>
        </tr>
        <tr>
          <td>Rarity</td>
          <td>
            <select v-model="itemRarity">
              <option>common</option>
              <option>uncommon</option>
              <option>rare</option>
              <option>legendary</option>
              <option>exotic</option>
            </select>  
          </td>
          <td></td>
          <td>For Sale?</td>
          <td>
            <select v-model="itemForSale">
              <option v-bind:value="true">true</option>
              <option v-bind:value="false">false</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Price</td>
          <td><input type="text" placeholder="Enter" align="center" v-model="itemPrice"/></td>
          <td></td>
          <td>Currency Type</td>
          <td>
            <select v-model="itemPriceCurrencyType">
              <option>sb</option>
              <option value="mt">mt (gold)</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Loot Box Type
          <td>
            <select v-model="lootBoxType">
              <option>random</option>
              <option>guaranteed</option>
            </select>
          </td>
          <td></td>
          <td>Max Per Day (0=unlimited)</td>
          <td><input type="text" placeholder="Enter" align="center" v-model="maxPerDay"/></td>
        </tr>
        <tr><td colspan=5 style="height:20px;background-color:#674a4a;"></td></tr>
        <tr>
          <td>Common</td>
          <td>Uncommon</td>
          <td>Rare</td>
          <td>Legendary</td>
          <td>Exotic</td>
        </tr>
        <tr>
          <td><input type="text" placeholder="" align="center" v-model="chanceCommon"/>%</td>
          <td><input type="text" placeholder="" align="center" v-model="chanceUncommon"/>%</td>
          <td><input type="text" placeholder="" align="center" v-model="chanceRare"/>%</td>
          <td><input type="text" placeholder="" align="center" v-model="chanceLegendary"/>%</td>
          <td><input type="text" placeholder="" align="center" v-model="chanceExotic"/>%</td>
        </tr>
        <tr>
          <td v-for="key in Object.keys(selectedMap)" :key=key>
            <div v-for="item in selectedMap[key]" :key="item.id" style="padding-top:5px; padding-bottom:5px;">
              <img :src="lootItemImageUrl(item)" style="width:50px;"/><br/>
              {{item.name}}
            </div>
          </td>
        </tr>
      </table>
      <br/>
      Current Total: {{chanceTotal}}% <span v-if="chanceTotal != 100">Total Must Be 100</span><br/>
      <button class="btn-enabled" @click="save()">SAVE<template v-if="isSaving">ing..</template></button>
      <br/>      <br/>
      <table border=1 style="width:100%;" v-if="roomItemPages[roomItemPageCurrent]"> 
        <tr v-for="item in roomItemPages[roomItemPageCurrent]['loot_items']" v-bind:key="item.id">
          <td><img :src="lootItemImageUrl(item)" style="width:100px;"/></td>
          <td>{{item.name}}</td>
          <td>{{item.rarity}}</td>
          <td>
            <button v-if="!containsSelected(item)" @click="addSelected(item)">Select</button>
            <button v-else @click="removeSelected(item)">Deselect</button>
          </td>
        </tr>
      </table>
      <button class="btn-enabled" @click="next()">Next</button>
      <button v-if="roomItemPageCurrent > 0" class="btn-enabled" @click="back()">Back</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import router from '../router'
import axios from 'axios'
// import loading from 'vue-full-loading'
// import BigNumber from 'BigNumber.js'
// import axios from 'axios'
// import router from '../router'

export default {
  name: 'loot-box-editor',
  props: ['itemId'],
  components: {
    // loading
  },
  async mounted () {
    await this.refreshLootItems()
    await this.loadItem()
  },
  data () {
    return {
      description: {
        title: 'Loot Box Editor',
        text: `Do it!`
      },
      selectedMap: {'common': [], 'uncommon': [], 'rare': [], 'legendary': [], 'exotic': []},
      isSaving: false,
      chanceCommon: 0,
      chanceUncommon: 0,
      chanceRare: 0,
      chanceLegendary: 0,
      chanceExotic: 0,
      maxPerDay: 0,
      itemName: '',
      itemDescription: '',
      itemRarity: 'common',
      itemForSale: false,
      itemPrice: '50',
      itemPriceCurrencyType: 'mt',
      notification: undefined,
      lootBoxType: 'random',
      existingItem: undefined
    }
  },
  computed: Object.assign(mapState(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems', 'roomItemPageCurrent', 'roomItemPages']), {
    chanceTotal () {
      return parseInt(this.chanceCommon) +
        parseInt(this.chanceUncommon) +
        parseInt(this.chanceRare) +
        parseInt(this.chanceLegendary) +
        parseInt(this.chanceExotic)
    },
    imageUrl () {
      return this.existingItem && this.existingItem.image_url ? this.existingItem.image_url : 'lootchest-first.jpg'
    }
  }),
  methods: {
    async loadItem () {
      if (this.$route.query.notify) {
        this.notify(this.$route.query.notify)
      }

      if (this.itemId) {
        this.$store.dispatch('fetchLootItem', this.itemId).then(() => {
          let item = this.$store.state.lootItems[this.itemId]
          this.existingItem = item
          this.itemName = item.name
          this.itemRarity = item.rarity
          this.itemDescription = item.description
          this.itemForSale = item.for_sale
          this.itemPrice = item.price
          this.itemPriceCurrencyType = item.price_currency_type
          this.itemMaxAllowed = item.max_allowed
          this.existingThumbnailUrl = item.image_url
          let arr
          if (item.meta.blbg) {
            this.lootBoxType = 'guaranteed'
            arr = item.meta.blbg
          } else {
            this.lootBoxType = 'random'
            arr = item.meta.blb
          }

          this.chanceCommon = arr[0][0]
          this.chanceUncommon = arr[0][1]
          this.chanceRare = arr[0][2]
          this.chanceLegendary = arr[0][3]
          this.chanceExotic = arr[0][4]

          this.selectedMap = {'common': [], 'uncommon': [], 'rare': [], 'legendary': [], 'exotic': []}

          for (let item of arr[1][0]) {
            this.$store.dispatch('fetchLootItem', item.li).then(() => this.selectedMap['common'].push(this.$store.state.lootItems[item.li]))
          }

          for (let item of arr[1][1]) {
            this.$store.dispatch('fetchLootItem', item.li).then((i) => this.selectedMap['uncommon'].push(this.$store.state.lootItems[item.li]))
          }

          for (let item of arr[1][2]) {
            this.$store.dispatch('fetchLootItem', item.li).then((i) => this.selectedMap['rare'].push(this.$store.state.lootItems[item.li]))
          }

          for (let item of arr[1][3]) {
            this.$store.dispatch('fetchLootItem', item.li).then((i) => this.selectedMap['legendary'].push(this.$store.state.lootItems[item.li]))
          }

          for (let item of arr[1][4]) {
            this.$store.dispatch('fetchLootItem', item.li).then((i) => this.selectedMap['exotic'].push(this.$store.state.lootItems[item.li]))
          }
        })
      }
    },
    next () {
      if (this.roomItemPages.length - 1 > this.roomItemPageCurrent) {
        this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent + 1)
      } else {
        this.$store.dispatch('fetchRoomPage', this.roomItemPages[this.roomItemPageCurrent].cursor)
      }
    },
    back () {
      this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent - 1)
    },
    async refreshLootItems () {
      await this.$store.dispatch('roomItemPageReset')
      this.$store.dispatch('fetchRoomPage')
    },
    categoryTextFor (shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST'
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item'
      } else {
        return 'Token'
      }
    },
    lootShopLootItemForId (id) {
      return this.$store.state.lootShopLootItems[id]
    },
    lootItemImageUrl (lootItem) {
      return `${Vue.config.WEB_ASSET_BASE_URL}/${lootItem.image_url}`
    },
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    },
    attributionText (lootItem) {
      if (!lootItem.attribution_author) { return }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return `<a href="${lootItem.attribution_title_url}" target="_blank">"${lootItem.attribution_title}"</a> by <a href="${lootItem.attribution_author_url}" target="_blank">${lootItem.attribution_author}</a> <br/> Licensed under <a href="${lootItem.attribution_license_url}" target="_blank">${lootItem.attribution_license}</a>`
    },
    requiresAttribution (lootItem) {
      return !!lootItem.attribution_author
    },
    notify (text) {
      this.notification = text
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    },
    lootBoxData () {
      console.log('rarity', this.itemRarity)
      return {
        name: this.itemName,
        description: this.itemDescription,
        rarity: this.itemRarity,
        for_sale: this.itemForSale,
        price: this.itemPrice,
        price_currency_type: this.itemPriceCurrencyType,
        loot_box_type: this.lootBoxType,
        max_per_day: this.maxPerDay,
        image_url: this.imageUrl,
        chances: [parseInt(this.chanceCommon), parseInt(this.chanceUncommon), parseInt(this.chanceRare), parseInt(this.chanceLegendary), parseInt(this.chanceExotic)],
        buckets: {
          'common': this.selectedMap['common'].map(i => i.id),
          'uncommon': this.selectedMap['uncommon'].map(i => i.id),
          'rare': this.selectedMap['rare'].map(i => i.id),
          'legendary': this.selectedMap['legendary'].map(i => i.id),
          'exotic': this.selectedMap['exotic'].map(i => i.id)
        }
      }
    },
    async save () {
      let response

      this.isSaving = true

      if (this.existingItem) {
        response = await axios.put(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/loot-boxes/${this.existingItem.id}`, this.lootBoxData(), {withCredentials: true})
      } else {
        response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/loot-boxes`, this.lootBoxData(), {withCredentials: true})
      }

      this.isSaving = false

      if (response.data) {
        let id = response.data.loot_item.id
        if (!this.itemId || this.itemId.toString() !== id.toString()) {
          router.push({ name: 'LootBoxEditor', query: { notify: 'Item Saved.' }, params: { itemId: id } })
        } else {
          this.notify('Item Saved')
        }
      } else {
        this.notify('ERROR SAVING.')
      }
    },
    containsSelected (item) {
      return this.selectedMap[item.rarity].map(i => i.id).includes(item.id)
    },
    addSelected (item) {
      this.selectedMap[item.rarity].push(item)
    },
    removeSelected (item) {
      this.selectedMap[item.rarity].splice(this.selectedMap[item.rarity].map(i => i.id).indexOf(item.id), 1)
    }
  },
  watch: {
    '$route.params.itemId': function (id) {
      this.loadItem()
    }
  }
}
</script>

<style scoped>
  .rarity-common {
    color: rgb(255, 255, 255);
  }

  .rarity-uncommon {
    color: rgb(17, 116, 14);
  }

  .rarity-rare {
    color: rgb(51, 81, 212);
  }

  .rarity-legendary {
    color: rgb(190, 34, 204);
  }

  .rarity-exotic {
    color: rgb(228, 197, 21);
  }
  .shop-image {
    max-width: 200px;
    max-height:200px;
  }

  .shop-item {
    width: 200px;
  }

  .currency-icon {
    max-width:20px;
    padding-left: 5px;
  }

  .price-content {
    display: flex; 
    align-items: center;  
    justify-content: center;
  }

  .btn-enabled{
    width:100%;
    display: inline-block;
    border-top: 4px var(--sl-red) solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-enabled:hover{
    background-color: var(--sl-red);
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: var(--sl-red);
    border-top: 4px rgb(255, 0, 0) solid;
}

tr:nth-child(even){
  background-color:#5a5a61;
}
tr:nth-child(odd){
  background-color:#484444;
}

.editor-table {
  width:100%;
  border:1px solid white;
  text-align:left;
}

</style><style>
a {
  text-decoration: none;
  color: #445278;
}

a:visited {
  color: #4d566e;
}

a:hover {
  color: #62729c;
}

</style>


// WEBPACK FOOTER //
// src/components/Loot-Box-Editor.vue